import { render, staticRenderFns } from "./PortalSubmissionList.vue?vue&type=template&id=d04f88b6&scoped=true&"
import script from "./PortalSubmissionList.vue?vue&type=script&lang=js&"
export * from "./PortalSubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./PortalSubmissionList.vue?vue&type=style&index=0&id=d04f88b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04f88b6",
  null
  
)

export default component.exports